import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelecaoPesquisaPage } from './selecao-pesquisa.page';
import { LoadingContainerComponentModule } from '../../components/loading-container/loading-container.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        LoadingContainerComponentModule
    ],
    declarations: [
        SelecaoPesquisaPage
    ],
    entryComponents: [
        SelecaoPesquisaPage
    ]
})
export class SelecaoPesquisaPageModule { }
